import { getPivotBlueshiftParams } from 'core/services/email/blueshift/implementations/generic'
import store from 'utils/store/withMiddleware'
import { ISC } from 'core/constants/channels'
import { sendBlueshiftEvent, BlueshiftEvent } from 'core/services/email/blueshift'

export function sendAddOnsViewEvent(): Promise<void> {
  const state = <Pivot.GenericKeyPair<any>>store.getState()
  const { dentalPlanId, latitudeId } = state
  const dataPayload = {
    ...getPivotBlueshiftParams(),
    want_dental_and_vision: dentalPlanId != null,
    want_supplemental: latitudeId != null
  }

  return sendBlueshiftEvent({
    dataPayload,
    eventName:
      dataPayload.sales_channel === ISC
        ? BlueshiftEvent.ISC_ADDONS_VIEW
        : BlueshiftEvent.ADDONS_VIEW,
    sanitize: true
  })
}
